import { render, staticRenderFns } from "./BagDetails.vue?vue&type=template&id=080a32b9"
import script from "./BagDetails.vue?vue&type=script&lang=js"
export * from "./BagDetails.vue?vue&type=script&lang=js"
import style0 from "./BagDetails.vue?vue&type=style&index=0&id=080a32b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports